import { Ecosystem } from "@protos/sca/v1/sca";

export const pttSupportedEcosystems: Array<Ecosystem> = [
  Ecosystem.pypi,
  Ecosystem.swiftpm,
  Ecosystem.npm,
  Ecosystem.maven,
];

export const scanBasedPttSupportedEcosystems: Array<Ecosystem> = [
  Ecosystem.maven,
];

export const showDependencyPaths = (
  ecosystem: Ecosystem,
  enableScanBasedPathToTransitivity: boolean,
  enableSbomBasedPathToTransitivity: boolean
) => {
  if (
    !enableSbomBasedPathToTransitivity &&
    !enableScanBasedPathToTransitivity
  ) {
    return false;
  }
  if (enableSbomBasedPathToTransitivity && enableScanBasedPathToTransitivity) {
    return (
      pttSupportedEcosystems.includes(ecosystem) ||
      scanBasedPttSupportedEcosystems.includes(ecosystem)
    );
  }
  if (enableScanBasedPathToTransitivity) {
    return scanBasedPttSupportedEcosystems.includes(ecosystem);
  }

  return pttSupportedEcosystems.includes(ecosystem);
};
